import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { WebhooksPage } from 'features/webhooks'
import { canViewConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/webhooks/')({
  component: WebhooksPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Webhooks'),
      },
    ],
  }),
  beforeLoad: protectWithWorkspacePermissions(canViewConfigurationPermission),
})
